<template>
  <section class="layer-section sku-service" v-if="allService.length">
    <div class="section-title">
      <a class="selectable" href="javascript:void(0);" @click="toServer">服务（可选）</a>
    </div>
    <div class="section-content service">
      <div class="btn-wrapper" v-for="(service, index) in allService" :key="index">
        <div
          @click="selectService(service)"
          :code="service.id"
          class="section-btn"
          :class="{ checked: service.id == (checkedService[service.type] && checkedService[service.type].id) }"
        >
          <p class="name">
            <span class="service-name">{{ service.name }}</span>
            <span class="pref-tag" v-if="service.salePrice < service.marketPrice">
              <template v-if="service.type == 4">
                立省
                <dfn>&yen;</dfn>
                {{ (service.marketPrice - service.salePrice) | formatNumber }}
              </template>
              <template v-else>限时优惠</template>
            </span>
            <span class="separator"></span>
            <dfn>&yen;</dfn>
            {{ service.salePrice | formatNumber }}
            <span class="market-price" v-if="service.salePrice < service.marketPrice">
              <dfn>&yen;</dfn>
              {{ service.marketPrice | formatNumber }}
            </span>
          </p>
        </div>
        <!-- 服务详情 -->
        <dl class="vivo-care-tip" v-if="isShowDetail(service)">
          <dt class="tit-box">
            <h4 class="tit">{{ service.name }}包含：</h4>
          </dt>
          <dd class="cut" v-html="service.intro"></dd>
        </dl>
      </div>
    </div>

    <!-- 服务协议 -->
    <div class="tip" v-if="isServiceInited">
      <v-checkbox v-model="isAgree" scale="0.8">我已阅读并同意</v-checkbox>
      <a
        class="terms"
        @click="
          toVivoCare(
            '/helpcenter/vivo-care-pact?broken=' +
              (spuInfo.brokenSvcs ? 1 : 0) +
              '&extend=' +
              (spuInfo.extendSvcs ? 1 : 0) +
              '&backCover=' +
              (spuInfo.backCoverSvcs ? 1 : 0) +
              '&vivoCare=' +
              (spuInfo.packSvcs ? 1 : 0) +
              '&renewal=' +
              (spuInfo.renewalSvcs ? 1 : 0) +
              '&active=' +
              activeTerm
          )
        "
        href="javascript:void(0);"
      >
        《vivo 服务条款》
      </a>
    </div>
  </section>
</template>

<script>
import { jumpToShop } from '@/utils/common'

export default {
  name: 'sku-service',
  props: {
    spuInfo: Object,
    checkedService: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      isServiceInited: false, // 当用户选择过服务后，协议才会出现，否则默认不出现
      isAgree: false // 是否勾选了服务协议
    }
  },
  computed: {
    // type 1 碎屏保， 2 延保， 3 后盖宝， 4 vivocare, 7 焕新宝
    allService() {
      return [
        ...(this.spuInfo.brokenSvcs || []),
        ...(this.spuInfo.extendSvcs || []),
        ...(this.spuInfo.backCoverSvcs || []),
        ...(this.spuInfo.packSvcs || []),
        ...(this.spuInfo.renewalSvcs || [])
      ]
    },
    activeTerm() {
      let result = 'broken'
      const serviceMap = {
        1: 'broken',
        2: 'extend',
        3: 'backCover',
        4: 'vivoCare',
        7: 'renewal'
      }
      for (let key in this.checkedService) {
        if (this.checkedService[key] && this.checkedService[key].id != '') {
          result = serviceMap[key]
          break
        }
      }
      return result
    }
  },
  watch: {
    checkedService: {
      deep: true,
      handler(checked) {
        checked = Object.values(checked).filter(item => !!item)
        // 只要有选中的服务，则自动同意协议
        this.isAgree = !!checked.length
        if (checked.length) {
          this.isServiceInited = true
        }
      }
    },
    isAgree(isAgree) {
      // 如果不同意协议，则取消所有选中项
      if (!isAgree) {
        this.$emit('serviceChange', 0)
      }
    }
  },
  methods: {
    /**
     * 选中服务信息
     * @param {Object} service - 选择的服务信息
     * @param {String} type -服务类型
     */
    selectService(service) {
      this.$emit('serviceChange', service.type, this.checkedService[service.type] === service ? '' : service)
      this.$emit('serviceClick', service)
    },
    /**
     * 当前服务是否被选中了
     */
    isShowDetail(service) {
      if (service.type == 4 || service.type == 7) {
        return service.id == (this.checkedService[service.type] && this.checkedService[service.type].id)
      }
      return false
    },
    /**
     * 跳转至服务页面
     */
    toServer() {
      jumpToShop('/helpcenter/broken-screen')
    },

    /**
     * 跳转至vivo服务条款
     */
    toVivoCare(route) {
      jumpToShop(route)
    }
  }
}
</script>
